module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNzAuMzQiIGhlaWdodD0iNDIyLjQ3NSIgdmlld0JveD0iMCAwIDM3MC4zNCA0MjIuNDc1Ij4KICA8cGF0aCBpZD0i44OR44K5XzM3NDciIGRhdGEtbmFtZT0i44OR44K5IDM3NDciIGQ9Ik01MTcuMjMyLDEyOTIuMDFWMTAwOS45bDM3MC4zNC0xNDAuMzY0djI4Mi4xMTFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTE3LjIzMSAtODY5LjUzNSkiIGZpbGw9ImJsdWUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/common/blue_370.svg
// module id = DkUD
// module chunks = 0